import React from "react";

const ShareOn = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="7" y="8" width="20" height="14" rx="2" fill="#FEB700" />
      <path
        d="M8.05273 25.9999C16.4738 23.931 17.5264 23.931 25.9475 26.0001"
        stroke="#FEB700"
        strokeWidth="2"
      />
      <path
        d="M17.67 16.7299C14.108 16.473 11.0725 18.8029 10 20C10.962 16.2978 15.5142 14.1849 17.67 13.5912V10L23 14.7883L17.67 19.5766V16.7299Z"
        fill="#023A4A"
      />
    </svg>
  );
};

export default ShareOn;
